import { useContext } from "react";
import ReplaySearchContext from "components/event-definitions/replay-search/ReplaySearchContext";
const useReplaySearchContext = () => useContext(ReplaySearchContext);
export default useReplaySearchContext;
